'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002470 from "./presto.-Credentials-View$$anon$70.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002472 from "./presto.-Credentials-View$$anon$72.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002474 from "./presto.-Credentials-View$$anon$74.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsage$0024 from "./presto.types$-Credential-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$69() {
  this.aI9 = null;
  this.aI1 = null;
  this.aI2 = false;
  this.aIa = null;
  this.aIb = false;
  this.aIe = null;
  this.aI7 = null;
  this.aI8 = false;
  this.aI3 = null;
  this.aI4 = false;
  this.aI5 = null;
  this.aI6 = false;
  this.aIc = false;
  this.aId = false;
  this.aI9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aIe = "CredentialUsage";
}
export { $c_Lpresto_CredentialsView$$anon$69 as $c_Lpresto_CredentialsView$$anon$69 };
$p = $c_Lpresto_CredentialsView$$anon$69.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$69;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$69() {
}
export { $h_Lpresto_CredentialsView$$anon$69 as $h_Lpresto_CredentialsView$$anon$69 };
$h_Lpresto_CredentialsView$$anon$69.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aI9;
});
$p.M = (function() {
  if ((!this.aI2)) {
    this.aI1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aI2 = true;
  }
  return this.aI1;
});
$p.O = (function() {
  if ((!this.aIb)) {
    this.aIa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aIb = true;
  }
  return this.aIa;
});
$p.E = (function() {
  return this.aIe;
});
$p.t = (function() {
  if ((!this.aI8)) {
    this.aI7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("inherited", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("location", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("reason", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("at", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonator", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aI8 = true;
  }
  return this.aI7;
});
$p.N = (function() {
  if ((!this.aI4)) {
    this.aI3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002470.$c_Lpresto_CredentialsView$$anon$70(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002472.$c_Lpresto_CredentialsView$$anon$72())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.aI4 = true;
  }
  return this.aI3;
});
$p.Q = (function() {
  if ((!this.aI6)) {
    this.aI5 = new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002474.$c_Lpresto_CredentialsView$$anon$74();
    this.aI6 = true;
  }
  return this.aI5;
});
$p.v = (function() {
  if ((!this.aId)) {
    this.aIc = false;
    this.aId = true;
  }
  return this.aIc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee220) => ((p) => \u03b4scrutinee220.cFK(p)))($j_presto$002etypes$0024$002dCredential$002dUsage$0024.$m_Lpresto_types$CredentialUsage$())));
});
var $d_Lpresto_CredentialsView$$anon$69 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$69, "presto.CredentialsView$$anon$69", ({
  Gy: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$69 as $d_Lpresto_CredentialsView$$anon$69 };
//# sourceMappingURL=presto.-Credentials-View$$anon$69.js.map
